export default "__VITE_ASSET__3e45be74__"